// import agent from './agent';
import {
  ASYNC_START,
  ASYNC_END,
  LOGOUT,
  LOGIN_WITH_TOKEN,
  REFRESH_TOKEN,
} from '../constants/actionTypes';

import { user } from 'src/actions';
import { setAuthCookie, deleteAuthCookie } from 'src/utils/cookies';

const authPromiseMiddleware = store => next => action => {
  if (isPromise(action.payload)) {
    store.dispatch({ type: ASYNC_START, subtype: action.type });

    const currentView = store.getState().viewChangeCounter;
    const skipTracking = action.skipTracking;

    return action.payload.then(
      res => {
        const currentState = store.getState();
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return;
        }
        action.payload = res;
        
        store.dispatch(action);
        store.dispatch({ type: ASYNC_END, promise: action.payload, subtype: action.type });
        return res;
      },
      error => {
        const currentState = store.getState();
        if (!skipTracking && currentState.viewChangeCounter !== currentView) {
          return;
        }
        
        action.error = true;
        action.payload = Array.isArray(error.response) ? error.response : error.response.data;

        store.dispatch(action);
        store.dispatch({ type: ASYNC_END, promise: action.payload, subtype: action.type });
        throw error;
      }
    );
  }
  return next(action);
};

const authMiddleware = store => next => action => {
  if (action.type === REFRESH_TOKEN || action.type === LOGIN_WITH_TOKEN) {
    if (!action.error) {
      setAuthCookie(action.payload.data.token);
    } else {
      deleteAuthCookie();
      store.dispatch(user.resetUser());
    }
  }

  if (action.type === LOGOUT) {
    deleteAuthCookie();
    store.dispatch(user.resetUser());
  }
  
  return next(action);
}

function isPromise(v) {
  return v && typeof v.then === 'function';
}


export { authPromiseMiddleware, authMiddleware };


// WEBPACK FOOTER //
// ./src/store/middleware.js